import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    RouterModule.forRoot([
      { path: '', loadChildren: './publico/publico.module#PublicoModule' },
      { path: '', loadChildren: './restrito/restrito.module#RestritoModule' },
      { path: 'not-found', loadChildren: './shared-layout/notfound/notfound.module#NotfoundModule' },
      {
        path: '**',
        redirectTo: 'not-found'
      }
    ])
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts